import { createSlice, isRejectedWithValue } from "@reduxjs/toolkit";

const loadAuthState = () => {
  return {
    user: null,
    token: null,
    refreshToken: null,
    tokenExpiresAt: null,
    isAuthenticated: false,
  };
};

// Auth Slice
const authSlice = createSlice({
  name: "auth",
  initialState: loadAuthState(),
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.tokenExpiresAt = null;
      state.isAuthenticated = false;
    },
    setToken: (state, action) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      if (action.payload.expiresAt) {
        state.tokenExpiresAt = action.payload.expiresAt;
      }
      state.isAuthenticated = !!action.payload.token;
    },
    updateCurrentUser: (state, action) => {
      const firstName = action.payload.given_name;
      const lastName = action.payload.family_name;
      const fullName = [firstName, lastName].filter(Boolean).join(' ');
      state.user = {
        id: action.payload.sub,
        firstName,
        lastName,
        name: fullName,
        email: action.payload.email,
        role: action.payload.role,
        brokerCompanyStatus: action.payload.broker_company_status || null,
        avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(fullName)}`,
      };
    },
  },
});

export const selectIsTokenExpired = (state) => {
  return state.auth.tokenExpiresAt && Date.now() > state.auth.tokenExpiresAt;
};

export const authMiddleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action) && action.payload?.isAuthError) {
    api.dispatch(logout());
    window.location.href = "/";
  }
  return next(action);
};

export const { logout, setToken, updateCurrentUser } = authSlice.actions;
export default authSlice.reducer;
